var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6.5,
    fill: "white",
    stroke: "#FF9B6B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.57748 10.8344C6.6882 10.9379 6.83967 11 7.00288 11C7.16609 11 7.31756 10.9379 7.42828 10.8344L10.8437 7.57963C11.0651 7.37259 11.0476 7.04148 10.8144 6.84998C10.5813 6.65336 10.2026 6.66889 9.98114 6.87574L7.56824 9.16811L7.56824 3.5175C7.56824 3.2328 7.30604 3 6.98539 3C6.66495 3 6.40254 3.2328 6.40254 3.5175L6.40254 9.16811L4.00734 6.87574C3.89065 6.7672 3.73917 6.71019 3.58173 6.71019C3.44199 6.71019 3.30203 6.75678 3.18555 6.84998C2.95237 7.0466 2.93487 7.37259 3.15632 7.57963L6.57748 10.8344Z",
    fill: "#FF9B6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleDownArrow);
export default __webpack_public_path__ + "static/media/circle-down-arrow.c4101b615b9cd26c35018944a49cbcb6.svg";
export { ForwardRef as ReactComponent };